import React from 'react';

export default function AdminSettings() {
    return (
        <div>
            <h1>AdminSettings</h1>
        </div>
    );
}
